import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'
import colors from '../../theme/foundations/colors'
import sizes from '../../theme/foundations/sizes'

export const orderSummaryHeading = {
    color: 'black',
    marginTop: pxToRem(22),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(22),
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: pxToRem(3),
    textTransform: 'uppercase',
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(20),
        fontSize: pxToRem(18)
    }
}

export const subtotalStyle = {
    color: 'black',
    marginTop: pxToRem(32),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(20),
        fontSize: pxToRem(14)
    }
}

export const currencyStyle = {
    color: 'black',
    marginTop: pxToRem(32),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(20),
        fontSize: pxToRem(14)
    }
}

export const shippingStyle = {
    color: 'black',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const giftCardStyle = {
    color: 'cav_red',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const shippingCurrencyStyle = {
    color: 'black',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const salesTaxStyle = {
    color: 'black',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const salesTaxCurrencyStyle = {
    color: 'black',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const freeTextStyle = {
    color: 'black',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const tbdStyle = {
    marginTop: pxToRem(25),
    marginBottom: '0px',
    lineHeight: 'normal',
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const noteStyle = {
    color: 'cav_light_input_gray',
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    marginTop: `${pxToRem(10)} !important`,
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: `${pxToRem(5)} !important`,
        fontSize: pxToRem(12)
    }
}

export const estimatedTotalStyle = {
    color: 'black',
    marginTop: pxToRem(20),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(14)
    }
}

export const estimatedCurrencyStyle = {
    color: 'black',
    marginTop: pxToRem(20),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(14)
    }
}

export const checkoutButtonStyle = {
    marginTop: pxToRem(45),
    backgroundColor: 'cav_red',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: pxToRem(14),
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    width: '100%',
    height: pxToRem(40),
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    borderRadius: '0px',
    '&:hover': {
        border: `${pxToRem(1)} solid ${colors.cav_red}`,
        borderRadius: '0px',
        textDecoration: 'none',
        backgroundColor: 'white',
        color: 'cav_red'
    },
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(20),
        fontSize: pxToRem(12)
    }
}

export const checkoutButtonDisabledStyle = {
    marginTop: pxToRem(45),
    backgroundColor: colors.reddish_hue,
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: pxToRem(14),
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    width: '100%',
    height: pxToRem(40),
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    borderRadius: '0px',
    color: 'white',
    cursor: 'not-allowed !important',
    opacity: '0.8',
    '&:hover': {
        backgroundColor: `${colors.reddish_hue} !important`,
        color: 'white !important',
        border: 'none !important',
        cursor: 'not-allowed !important'
    },
    '&:focus': {
        cursor: 'not-allowed !important'
    },
    '&:active': {
        cursor: 'not-allowed !important'
    },
    '*': {
        cursor: 'not-allowed !important'
    },
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(20),
        fontSize: pxToRem(12)
    }
}

export const applyButtonStyle = {
    backgroundColor: 'cav_red',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: pxToRem(14),
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    width: pxToRem(92),
    height: pxToRem(40),
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    borderRadius: '0px',
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(12)
    }
}

export const iconStyle = {
    marginTop: pxToRem(25),
    marginBottom: pxToRem(23),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(10),
        marginBottom: pxToRem(20)
    }
}

export const editCartItemStyle = {
    marginTop: {
        base: pxToRem(21),
        md: pxToRem(31)
    },
    color: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: {
        base: pxToRem(14),
        md: pxToRem(16)
    },
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}
export const editCartButtonStyle = {
    width: '100%',
    color: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: {
        base: pxToRem(10),
        md: pxToRem(12)
    },
    marginTop: {
        base: `${pxToRem(10)} !important`,
        md: `${pxToRem(16)} !important`
    },
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    textTransform: 'uppercase',
    textDecoration: 'none',
    _hover: {
        textDecoration: 'none'
    },
    _focus: {
        textDecoration: 'none'
    }
}

export const promotionCodeLabelStyle = {
    color: 'black',
    marginBottom: [pxToRem(10)],
    marginTop: [pxToRem(20)],
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(16), pxToRem(16), pxToRem(16)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}

export const tagIconStyle = {
    w: pxToRem(16.17),
    h: pxToRem(16.17),
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    flex: 'none',
    mt: pxToRem(3),
    [`@media (max-width: ${sizes.container.md})`]: {
        width: pxToRem(16.17),
        height: pxToRem(16.17)
    }
}

export const couponStyle = {
    m: 0,
    flex: 1,
    color: 'cav_yello_green',
    ml: '3px',
    fontFamily: fonts.primary,
    fontSize: {base: pxToRem(14), md: pxToRem(16)}
}

export const removeStyle = {
    fontFamily: fonts.primary,
    color: 'cav_light_input_gray',
    fontSize: {base: pxToRem(14), md: pxToRem(16)},
    ml: {base: pxToRem(15), md: pxToRem(20)}
}

export const dividerStyle = {
    color: colors.blackAlpha[550]
}

export const productItemStyles = {
    imageStyle: {
        w: {base: '127px', md: '195px'},
        h: {base: '127px', md: '195px'}
    }
}
